import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkImportModal = ({ isOpen, onClose, onImport }) => {
  const [file, setFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  if (!isOpen) return null;

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragging(false);
    const droppedFile = e?.dataTransfer?.files?.[0];
    if (droppedFile && (droppedFile?.type === 'text/csv' || droppedFile?.name?.endsWith('.xlsx'))) {
      setFile(droppedFile);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e?.target?.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleImport = () => {
    if (file) {
      onImport(file);
      setFile(null);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-xl shadow-2xl border border-border max-w-2xl w-full mx-4 p-6 md:p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Import Data Peternak</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X"
          >
            <span className="sr-only">Tutup</span>
          </Button>
        </div>

        <div
          className={`border-2 border-dashed rounded-xl p-8 md:p-12 text-center transition-colors ${
            isDragging ? 'border-primary bg-primary/5' : 'border-border'
          }`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="Upload" size={32} color="var(--color-primary)" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {file ? file?.name : 'Drag & drop file atau klik untuk upload'}
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            Format yang didukung: CSV, XLSX (maksimal 5MB)
          </p>
          <input
            type="file"
            accept=".csv,.xlsx"
            onChange={handleFileChange}
            className="hidden"
            id="file-upload"
          />
          <label htmlFor="file-upload">
            <Button
              variant="outline"
              iconName="FileUp"
              iconPosition="left"
              as="span"
            >
              Pilih File
            </Button>
          </label>
        </div>

        <div className="mt-6 bg-muted/30 rounded-lg p-4">
          <h4 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
            <Icon name="Info" size={16} color="var(--color-primary)" />
            Template Format
          </h4>
          <p className="text-sm text-muted-foreground mb-3">
            File harus memiliki kolom berikut:
          </p>
          <div className="text-xs text-muted-foreground font-mono bg-background rounded p-3">
            Nama, Lokasi, Region, Telepon, Email, Luas Lahan, Jumlah Ternak, Volume Harian, Rating Kualitas
          </div>
          <Button
            variant="link"
            size="sm"
            iconName="Download"
            iconPosition="left"
            className="mt-3"
          >
            Download Template
          </Button>
        </div>

        <div className="flex items-center gap-3 mt-6 pt-6 border-t border-border">
          <Button
            variant="default"
            onClick={handleImport}
            disabled={!file}
            iconName="Upload"
            iconPosition="left"
          >
            Import Data
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            iconName="X"
            iconPosition="left"
          >
            Batal
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkImportModal;